import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import {
  Header, About, Skills, Projects, Education, Contact, Footer,
} from "../containers";

const Home = () => {
  const location = useLocation();

  // When arriving back from a sub-page with a target section, scroll to it.
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      setTimeout(() => scroller.scrollTo(target, { smooth: true, offset: -90, duration: 400 }), 60);
    }
  }, [location.state]);

  return (
    <>
      <Header />
      <About />
      <Skills />
      <Projects />
      <Education />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
